<template>
  <div>
    <v-layout wrap>
      <v-flex v-bind="{ [columnType]: true }"
        v-for="item in selectedAllergens"
        :key="item.ID"
        style="padding:3px;"
        :style="{'max-width': isDesktop ? '30px' : null}"
      >
        <center>
          <v-img     
            :src="item.Image"
            style="width: 24px;height:auto"
          />
        </center>
      </v-flex>
    </v-layout>    
  </div>
</template>
<script>
  import api from '@/services/api'
  import utils from '@/services/utils'
  export default {
    props: {
      allergens: {
        type: Array,
        required: true,        
      },
      columnType: {
        type: String,
        required: false,
        default: 'xs2'
      }
    },
    data () {
      return {
        allergensResponse: [],
        selectedAllergens: []
      }
    },
    computed: {
      isDesktop () {
        return !utils.isMobile();
      },
    },
    mounted () {
      const enterpriseIDDomain = this.$store.state.app.enterpriseID ? this.$store.state.app.enterpriseID : utils.getDomain()
      api.getItem('utils', false, `allergens/${enterpriseIDDomain}`).then(response => {
        this.allergensResponse = response.data.map(item => {
          item.FullName = item.Name,
          item.Name = utils.getTranslation (item.Name, this.locale)
          item.Image = `https://www.dtouch.es/assets/allergens/${item.Image}.png`
          return item
        })
        
        this.selectedAllergens = this.allergensResponse.filter(x => this.allergens.indexOf(x.ID)>=0)
      })
    }
  }
</script>
